import http from "../common/http-common";
import authHeader from '../common/auth-header';




//body: JSON.stringify(aCase)

class StudentDataService {





    getAll(params) {
        //console.log(params);
        var headers = authHeader();
        let config = {
            headers,
            params: params,
        }
        //console.log(config)

        return http.get("/students", config);
    }





    get(id) {
        var headers = authHeader();
        let config = {
            headers,
        }
        //console.log(config)
        return http.get(`/students/${id}`, config);
    }


    getByLastName(lstName){
        //console.log(lstName);
        let params = {};
        params["lastNameFilter"] = lstName;
        var headers = authHeader();
        let config = {
            headers,
            params: params,
        }
        //console.log(config)

        return http.get("/students", config);
    }


    create(event) {
        var headers = authHeader();
       // console.log('event.target.startDate.value : ' + event.target.startDate.value);
        var raw = JSON.stringify({
            "firstName": event.target.firstName.value,
            "lastName": event.target.lastName.value,
            "email": event.target.email.value,
            "phone": event.target.phone.value,
            "address": event.target.address.value,
            "zipCode": event.target.zipCode.value,
            "city": event.target.city.value,
            "company": event.target.company.value,
            "comments": event.target.comments.value,
            "salutation": event.target.salutation.value,
            "country": "France"
        });

        //console.log(raw);
        let config = {
            headers,
        }
        return http.post("/students", raw, config);
    }

    update(id, event) {
        var headers = authHeader();
        //console.log('event.target.studentId.value : ' + event.target.studentId.value);
        //console.log(event);
        var raw = JSON.stringify({
            "firstName": event.target.firstName.value,
            "lastName": event.target.lastName.value,
            "email": event.target.email.value,
            "phone": event.target.phone.value,
            "address": event.target.address.value,
            "zipCode": event.target.zipCode.value,
            "city": event.target.city.value,
            "company": event.target.company.value,
            "comments": event.target.comments.value,
            "salutation": event.target.salutation.value,
            "country": "France"
        });


        //console.log(raw);
        let config = {
            headers,
        }
        return http.put(`/students/${id}`, raw, config);
    }

    delete(id) {
        var headers = authHeader();
        let config = {
            headers,
        }
        //console.log(config)
        return http.delete(`/students/${id}`, config);
    }

    deleteAll() {
        return http.delete("/students");
    }



}

export default new StudentDataService();
